module.exports = __webpack_public_path__ + "img/playstore1.1b16c092.svg";